import { css } from '@emotion/react';
import { margins } from '@spotnana/blocks/src/utils';

export const container = css`
  ${margins.yt.m2}
`;
